import UserDispatcherListResponse, {
  UserDispatcherListResponseItem,
  UserDispatcherListResponseItemCargoCompany,
  UserDispatcherListResponseItemDispatcher,
} from "../../../../api/raily/user/dispatcher/list/user-dispatcher-list.response";
import UserDispatcherList, {
  UserDispatcherListItem,
} from "./user-dispatcher-list";

const createAlternativePhoneNumber = (
  responseDataItem: UserDispatcherListResponseItem,
): UserDispatcherListItem["alternativePhoneNumber"] => {
  if (
    !responseDataItem.mobileSecondary ||
    !responseDataItem.mobileSecondaryPrefix
  ) {
    return null;
  }

  return {
    dialingCode: responseDataItem.mobileSecondaryPrefix,
    number: responseDataItem.mobileSecondary,
  };
};

const createPhoneNumber = (
  responseDataItem: UserDispatcherListResponseItem,
): UserDispatcherListItem["phoneNumber"] => {
  return {
    dialingCode: responseDataItem.mobilePrimaryPrefix,
    number: responseDataItem.mobilePrimary,
  };
};

const createCargoCompany = (
  cargoCompany: UserDispatcherListResponseItemCargoCompany,
): UserDispatcherListItem["cargoCompany"] => {
  return {
    displayName: cargoCompany.displayName,
  };
};

const createDispatch = (
  dispatch: UserDispatcherListResponseItemDispatcher,
): UserDispatcherListItem["dispatch"] => {
  return {
    name: dispatch.dispatchName,
  };
};

const createDataItem = (
  responseDataItem: UserDispatcherListResponseItem,
): UserDispatcherListItem => {
  return {
    uuid: responseDataItem.id,
    removalDate: responseDataItem.removedAt,
    alternativePhoneNumber: createAlternativePhoneNumber(responseDataItem),
    cargoCompany: createCargoCompany(
      responseDataItem.dispatcher.dispatch!.cargoCompany,
    ),
    dispatch: createDispatch(responseDataItem.dispatcher.dispatch!),
    email: responseDataItem.email,
    firstName: responseDataItem.firstName,
    lastName: responseDataItem.lastName,
    username: responseDataItem.username,
    phoneNumber: createPhoneNumber(responseDataItem),
  };
};

const createData = (
  responseData: UserDispatcherListResponseItem[],
): UserDispatcherListItem[] => {
  return responseData.map(createDataItem);
};

const create = (response: UserDispatcherListResponse): UserDispatcherList => {
  return {
    data: createData(response.data.data),
    totalCount: response.data.totalCount,
  };
};

const userDispatcherListFactory = {
  create,
};

export default userDispatcherListFactory;
